import { render, staticRenderFns } from "./salOrderAccountDialog.vue?vue&type=template&id=4ca8a21c&scoped=true"
import script from "./salOrderAccountDialog.vue?vue&type=script&lang=js"
export * from "./salOrderAccountDialog.vue?vue&type=script&lang=js"
import style0 from "./salOrderAccountDialog.vue?vue&type=style&index=0&id=4ca8a21c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8a21c",
  null
  
)

export default component.exports